/** Calendar age in whole years. A missing date of birth is not an age. */
export function ageInYears(dateOfBirth: string | null | undefined, today = new Date()): number | null {
  if (!dateOfBirth) return null;
  const dob = new Date(`${dateOfBirth.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(dob.getTime())) return null;
  let age = today.getUTCFullYear() - dob.getUTCFullYear();
  const month = today.getUTCMonth() - dob.getUTCMonth();
  if (month < 0 || (month === 0 && today.getUTCDate() < dob.getUTCDate())) age -= 1;
  return age;
}

/**
 * Safe default: under 18, or a player account with no date of birth.
 * If two dates disagree, the younger one wins.
 */
export function isMinor(input: {
  dateOfBirth?: string | null;
  profileDob?: string | null;
  hasPlayerRole?: boolean;
  today?: Date;
}): boolean {
  const today = input.today ?? new Date();
  const ages = [ageInYears(input.dateOfBirth, today), ageInYears(input.profileDob, today)].filter(
    (age): age is number => age !== null,
  );
  if (ages.length === 0) return Boolean(input.hasPlayerRole);
  return Math.min(...ages) < 18;
}

export const PARENTAL_CONSENT_VERSION = "2026-10-12";

export const PARENTAL_CONSENT_TEXT = {
  en: "I am the parent or legal guardian. I consent to FanJago collecting and using this child's account, club, and safeguarding data as described in the privacy notice. I can withdraw this consent later.",
  ms: "Saya ibu bapa atau penjaga sah. Saya bersetuju FanJago mengumpul dan menggunakan data akaun, kelab, dan perlindungan kanak-kanak ini seperti dalam notis privasi. Saya boleh menarik balik persetujuan ini kemudian.",
};
